import React from "react";
import { Center, Spinner, CenterProps } from "@chakra-ui/react";

interface Props extends CenterProps {}

const LoadingOverlay = (props: Props) => (
  <Center h="100%" {...props}>
    <Spinner size="xl" />
  </Center>
);

export default LoadingOverlay;
